import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createContractDataAccessor } from './createContractDataLocator';
var tokenRegex = /\{\{(.*?)\}\}/g;
export var ParameterTemplate = /*#__PURE__*/function () {
  function ParameterTemplate(sources) {
    _classCallCheck(this, ParameterTemplate);
    _defineProperty(this, "visitedObjects", []);
    _defineProperty(this, "getSourceValue", void 0);
    this.getSourceValue = createContractDataAccessor(sources);
  }
  return _createClass(ParameterTemplate, [{
    key: "traverse",
    value: function traverse(object) {
      var outputObject = object instanceof Array ? [] : {};
      if (_typeof(object) !== 'object' || object === null) {
        return object;
      }
      for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (_typeof(value) === 'object' && !this.visitedObjects.includes(value)) {
          this.visitedObjects.push(value);
          outputObject[key] = this.traverse(value);
        } else if (typeof value === 'string') {
          var templateTokens = _toConsumableArray(value.matchAll(tokenRegex)).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              _everything = _ref2[0],
              templateToken = _ref2[1];
            return templateToken;
          });
          var outputValue = value;
          var _iterator = _createForOfIteratorHelper(templateTokens),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var token = _step.value;
              var templateString = "{{".concat(token, "}}");
              var shouldReplaceValueCompletely = templateString === value;
              var sourceValue = shouldReplaceValueCompletely ? this.getSourceValue(token) : this.getTemplateLiteralSafeValue(token);
              if (sourceValue === undefined) {
                //  leave token as-is
                continue;
              }
              if (shouldReplaceValueCompletely) {
                outputValue = sourceValue;
              } else {
                outputValue = outputValue.replace(templateString, sourceValue.toString());
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          outputObject[key] = outputValue;
        } else if (typeof value === 'boolean' || typeof value === 'number') {
          outputObject[key] = value;
        }
      }
      return outputObject;
    }
  }, {
    key: "getTemplateLiteralSafeValue",
    value: function getTemplateLiteralSafeValue(pathToken) {
      var extractedValue = this.getSourceValue(pathToken);
      if (typeof extractedValue === 'string') {
        return extractedValue;
      }
      if (typeof extractedValue === 'number') {
        return extractedValue;
      }
      return undefined;
    }
  }], [{
    key: "replace",
    value: function replace(object) {
      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }
      var instance = new ParameterTemplate(sources);
      return instance.traverse(object);
    }
  }]);
}();